<template>
  <user-center-wrap>
    <div class="personal-content">
      <div class="personal-contenter">
        <!-- <div class="title">账号绑定</div> -->
        <div class="open-list">
          <!-- <div class="link top">
            <img src="./img/mine_means_phone.png" alt="" />
            <div class="text">
              <h6>修改绑定手机</h6>
              <p>
                {{ userInfo.formatPhone ? "已绑定：" + `${userInfo.formatPhone}` : "您还没有绑定手机" }}
              </p>
            </div>
            <button @click="showPhone" class="edit-phone">{{ userInfo.mobile ? "修改手机" : "绑定手机" }}</button>
          </div> -->
          <!-- <div class="link top" to="/user-center/become-anchor" style="margin-left: 0">
            <img src="./img/mine_means_mima.png" alt="" />
            <div class="text">
              <h6>登录密码</h6>
              <p>
                {{ assetInfo.isset_passwrod ? "您已设置密码" : "您还没有设置登录密码" }}
              </p>
            </div>
            <button @click="setPassword()" class="activeClass">
              {{ assetInfo.isset_passwrod ? "修改密码" : "设置密码" }}
            </button>
          </div> -->
          <!-- <div class="link top">
            <img src="./img/mine_means_yinhangka.png" alt="" />
            <div class="text">
              <h6>银行卡绑定</h6>
              <p>
                {{ assetInfo.isbind_bank_card === 0 ? "您还没有绑定银行卡" : "您已绑定银行卡" }}
              </p>
            </div>
            <button @click="bankCard(userInfo)" class="activeClass">
              {{ assetInfo.isbind_bank_card === 0 ? "立即绑定" : "已绑定" }}
            </button>
          </div> -->
          <!-- <div class="link top">
            <img src="./img/mine_means_shiming.png" alt="" />
            <div class="text">
              <h6>实名认证</h6>
              <p>您还没有实名认证</p>
            </div>
            <button @click="startLive(userInfo)" class="activeClass">
              {{ assetInfo.is_anchor != 0 ? "立即认证" : "已认证" }}
            </button>
          </div> -->
          <!-- <div class="link top">
            <img src="./img/mine_means_zhifu.png" alt="" />
            <div class="text">
              <h6>支付密码</h6>
              <p>
                {{ assetInfo.isset_pay_password ? "您已设置支付密码" : "您还没有设置支付密码" }}
              </p>
            </div>
            <button class="activeClass" @click="setPayPassword">
              {{ assetInfo.isset_pay_password ? "修改密码" : "设置密码" }}
            </button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 修改登录密码 -->
    <el-dialog
      :title="assetInfo.isset_passwrod ? '修改登录密码' : '设置登录密码'"
      :visible.sync="showLoginPsd"
      width="432px"
      :show-close="false"
    >
      <el-form
        label-width="75px"
        label-position="left"
        style="margin-left: 24px; margin-top: 24px"
      >
        <el-form-item label="密码">
          <el-input
            v-model="passwordLoginData.pwd"
            placeholder="请输入新密码(6-12个字母和数字)"
            style="width: 304px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="userInfo.mobile" readonly="" style="width: 304px">
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" style="margin-bottom: 48px">
          <el-input
            v-model="passwordLoginData.smscode"
            placeholder="请输入验证码"
            style="width: 304px"
            maxlength="6"
          >
            <div
              slot="suffix"
              :class="[!isSend ? 'send_class' : 'last_down_time']"
              @click.stop="beforeSendCode"
            >
              {{ sendText }}
            </div>
          </el-input>
        </el-form-item>

        <SlideVerify
          v-if="showSlideVerify"
          class="slide-verify-pos"
          :h="171"
          :w="280"
          :sw="40"
          :sh="49"
          @success="verifySuccess"
          @close="showSlideVerify = false"
        />
      </el-form>
      <span slot="footer" class="dialog-footer-my">
        <el-button class="cancel" @click="showLoginPsd = false">取消</el-button>
        <el-button class="confirm" type="primary" @click="submitPassword"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改支付密码 -->
    <el-dialog
      :title="assetInfo.isset_pay_password ? '修改支付密码' : '设置支付密码'"
      :visible.sync="showPayPsd"
      width="432px"
      :show-close="false"
    >
      <el-form
        label-width="75px"
        label-position="left"
        style="margin-left: 24px; margin-top: 24px"
      >
        <el-form-item label="密码">
          <el-input
            v-model="passwordPayData.pwd"
            placeholder="请输入6位数字密码"
            style="width: 304px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="userInfo.mobile" style="width: 304px" readonly>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" style="margin-bottom: 48px">
          <el-input
            v-model="passwordPayData.smscode"
            placeholder="请输入验证码"
            style="width: 304px"
            maxlength="6"
          >
            <div
              slot="suffix"
              :class="[!isSend ? 'send_class' : 'last_down_time']"
              @click="sendCode"
            >
              {{ sendText }}
            </div>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer-my">
        <el-button class="cancel" @click="showPayPsd = false">取消</el-button>
        <el-button class="confirm" type="primary" @click="submitPayPassword"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 手机号修改 -->
    <el-dialog
      title="手机号修改"
      :visible.sync="showPhoneEdit"
      width="432px"
      :show-close="false"
    >
      <el-form
        label-width="75px"
        label-position="left"
        style="margin-left: 24px; margin-top: 24px"
      >
        <div class="tab_change">
          <div :class="['first_step', showNext ? 'first_step_inactive' : '']">
            1 安全验证
          </div>
          <div :class="['second_step', showNext ? 'second_step_active' : '']">
            2 绑定新手机号
          </div>
        </div>
        <el-form-item :label="!showNext ? '原号码' : '新号码'">
          <el-input
            v-model="oldPhone"
            style="width: 304px"
            :readonly="!showNext"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="验证码"
          style="margin-bottom: 48px"
          v-if="!showNext"
        >
          <el-input
            v-model="ori_sms_code"
            placeholder="请输入验证码"
            style="width: 304px"
            maxlength="6"
          >
            <div
              slot="suffix"
              :class="[!isSend ? 'send_class' : 'last_down_time']"
              @click="sendCode"
            >
              {{ sendText }}
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" style="margin-bottom: 48px" v-else>
          <el-input
            v-model="new_smscode"
            placeholder="请输入验证码"
            style="width: 304px"
            maxlength="6"
          >
            <div
              slot="suffix"
              :class="[!isSend ? 'send_class' : 'last_down_time']"
              @click="sendCode"
            >
              {{ sendText }}
            </div>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer-my">
        <el-button class="cancel" @click="closePhoneEdit">取消</el-button>
        <el-button class="confirm" type="primary" @click="nextStep"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import VipAlert from "../../components/vip-alert/vip-alert";
import { mapState, mapMutations, mapActions } from "vuex";
import { post, get } from "../../util/http";
import CenterCommon from "../../components/center-common/center-common";
import SlideVerify from "@/components/slide-verify";
export default {
  // async asyncData({ query, req, error, redirect }) {
  //   if (req && process.server && getPlatform(req) === "h5") {
  //     redirect(h5Host + "/user-center");
  //   }
  // },
  name: "user-center",
  // layout: "common-footer",
  // middleware: "login-check",
  components: {
    UserCenterWrap,
    VipAlert,
    CenterCommon,
    SlideVerify,
  },
  data() {
    return {
      assetInfo: {},
      oldPhone: "",
      new_smscode: "",
      ori_sms_code: "",
      isSend: false,
      sendText: "点击发送",
      visibleAddMoney: false,
      showLoginPsd: false,
      showPayPsd: false,
      showPhoneEdit: false,
      showNext: false,
      phoneFirstStep: true,

      updatePasswordForm: {
        password: "",
        verifiedCode: "",
      },
      payInputType: "password", // 支付密码输入框切换
      passwordInputType: "password", // 密码输入框切换
      payForm: {
        payPassword: "",
        smscode: "",
      },
      passwd: "",
      form: {},
      value: "",
      passwordLoginData: {
        pwd: "",
        smscode: "",
      },
      passwordPayData: {
        pwd: "",
        smscode: "",
      },
      timeId: null,
      showSlideVerify: false,
    };
  },
  mounted() {
    // this.getUserInfo();
    if (this.userInfo.id) {
      this.getInfoState();
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["changeUserInfo"]),
    ...mapActions(["getUserInfo", "toLogout"]),
    resetTimeId() {
      this.sendText = "点击发送";
      this.isSend = false;
      clearInterval(this.timeId);
    },

    beforeSendCode() {
      if (this.isSend) return;

      this.showSlideVerify = true;
    },

    verifySuccess() {
      this.showSlideVerify = false;
      this.sendCode();
    },

    async sendCode() {
      let mobile = this.userInfo.mobile;
      if (this.showNext) {
        mobile = this.oldPhone;
      }
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/sendVerifyCode",
        data: { mobile },
      });
      console.log(data, "-----");
      if (status == 0) {
        this.$message.success("发送成功");
        this.isSend = true;
        let time = 60;
        this.sendText = time + "s";
        this.timeId = setInterval(() => {
          time--;
          this.sendText = time + "s";
          if (time <= 0) {
            this.sendText = "重新发送";
            this.isSend = false;
            clearInterval(this.timeId);
          }
        }, 1000);
      }
    },
    async getInfoState() {
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/getUserAsset",
      });
      if (status == 0) {
        this.assetInfo = data;
      }
    },
    async nextStep() {
      if (!this.showNext) {
        if (!this.ori_sms_code) {
          // return this.$message.warning("验证码不能为空");
        }
        try {
          const {
            data: { data, status, msg },
          } = await post({
            url: "/api/user/checkSmsCode",
            data: {
              mobile: this.userInfo.mobile || "",
              smscode: this.ori_sms_code || "",
            },
          });
          if (status == 0) {
            this.oldPhone = "";
            this.showNext = true;
            this.resetTimeId();
          } else {
            // this.$message.error(e.message);
          }
        } catch (e) {
          // this.$message.error(e.message);
        }
      } else {
        try {
          const {
            data: { data, status, msg },
          } = await post({
            url: "/api/user/changeMobile",
            data: {
              new_smscode: this.new_smscode,
              ori_sms_code: this.ori_sms_code,
              new_mobile: this.oldPhone,
            },
          });
          if (status == 0) {
            this.$message.success("手机号修改成功");
            this.getUserInfo();
            this.closePhoneEdit();
          }
        } catch (e) {}
      }
    },
    closePhoneEdit() {
      this.showPhoneEdit = false;
      this.showNext = false;
      this.new_smscode = "";
      this.ori_sms_code = "";
      this.resetTimeId();
    },
    // 修改支付密码
    async submitPayPassword() {
      if (!this.passwordPayData.pwd) {
        return this.$message.error("新密码不能为空");
      }
      if (!this.passwordPayData.smscode) {
        return this.$message.error("验证码不能为空");
      }
      try {
        const {
          data: { data, status, msg },
        } = await post({
          url: "/api/user/changePayPwd",
          data: this.passwordPayData,
        });
        if (status == 0) {
          this.$message.success("操作成功");
          this.showPayPsd = false;
          this.changeUserInfo({
            ...this.userInfo,
            pay_password: 1,
          });
        }
      } catch (e) {
        console.log(e);
        // this.$message.warning(e.message);
      }
    },
    // 修改密码
    async submitPassword() {
      if (!this.passwordLoginData.pwd) {
        return this.$message.error("新密码不能为空");
      }
      if (this.passwordLoginData.pwd.length < 6) {
        return this.$message.error("新密码长度至少为6位");
      }
      if (this.passwordLoginData.pwd.length > 12) {
        return this.$message.error("新密码长度不能超过12位");
      }
      if (!/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/.test(this.passwordLoginData.pwd)) {
        return this.$message.error("您的密码必须包含字母和数字");
      }
      if (!this.passwordLoginData.smscode) {
        return this.$message.error("验证码不能为空");
      }
      try {
        const {
          data: { data, status, msg },
        } = await post({
          url: "/api/user/changePwd",
          data: this.passwordLoginData,
        });
        if (status == 0) {
          this.$message.success("密码修改成功，请重新登录");
          this.showLoginPsd = false;
          this.changePswLogout();
        }
      } catch (e) {
        // this.$message.warning(e.message);
        console.log(e);
      }
    },
    changePswLogout() {
      get({ url: "/api/user/logout" });
      this.toLogout();
      this.changeUserInfo({});
      this.$router.push("/");
    },
    startLive(items) {
      if (items.is_anchor === 0) {
        return this.$router.push("/user-center/apply-anchor");
      } else {
        return false;
      }
    },
    bankCard() {
      return this.$router.push("/user-center/myWallet?bank=1");
    },
    showPhone() {
      this.showNext = false;
      this.showPhoneEdit = true;
      this.oldPhone = this.userInfo.mobile;
      this.resetTimeId();
    },

    // 打开设置密码弹窗
    setPassword() {
      this.passwordInputType = "password";
      this.updatePasswordForm.password = "";
      this.updatePasswordForm.verifiedCode = "";
      this.showLoginPsd = true;
      this.resetTimeId();
    },

    // 打开支付密码设置弹窗
    setPayPassword() {
      this.payInputType = "password";
      this.payForm.payPassword = "";
      this.payForm.smscode = "";
      this.showPayPsd = true;
      this.resetTimeId();
    },
  },
};
</script>
<style scoped lang="stylus">
@import '../../assets/variable.styl';
/deep/ .el-input--small .el-input__inner{
  height:40px;
}

.slide-verify-pos {
  position: absolute;
  max-width: 350px;
  top: 35px;
  left: 50%;
  transform: translate3d(-50%, 10px, 10px);
  background-color: #fff;
}

.tab_change{
  width:384px;
  height:40px;
  display:flex;
  margin-bottom: 24px
  .first_step{
    width: 191px;
    height: 40px;
    text-align:center;
    line-height:40px;
    background: #26D99D;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    color: #FFFFFF;
    position: relative;
  }
   .first_step:before{
      content: "";
      width: 0px;
      height: 0px;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #26D99D;
      position: absolute;
      top: 0;
      right:-20px;
      z-index:2;
  }
  .first_step_inactive{
    background: rgba(38,217,157,0.10);
    color: #999999;
  }
  .first_step_inactive:before{
    border-left: 20px solid #e9fbf5;
  }
  .second_step{
    width: 188px;
    height: 40px;
    text-align:center;
    line-height:40px;
    background: rgba(38,217,157,0.10);
    border-radius: 0 4px 4px 0;
    font-size: 14px;
    font-size: 14px;
    color: #999999;
    position: relative;
  }
  .second_step_active{
    color: #FFFFFF;
    background: #26D99D;
  }
  //  .second_step_active:before{
  //     content: "";
  //     width: 0px;
  //     height: 0px;
  //     border-top: 20px solid transparent;
  //     border-bottom: 20px solid transparent;
  //     border-left: 20px solid #26D99D;
  //     position: absolute;
  //     top: 0;
  //     left:-20px;
  // }
}
.number86 {
  width: 44px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ddd;
  color: #666;
  font-size: 14px;
  border-radius: 3px;
  margin-left: -5px;
}

.phone_step {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 18px;
}

.select_area {
  display: flex;
  width: 318px;
  justify-content: space-between;
}

.text_qx, .special_text {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.special_text {
  color: #1c8c7a;

  &.payPassword_text {
    height: 14px;
    margin-bottom: 31px;
    width: 320px;
    display: flex;
    justify-content: center;
  }

  &.updataPassword_text {
    height: 14px;
    margin-bottom: 27px;
    width: 320px;
  }
}

.code_last {
  display: flex;
  justify-content: space-between;
  width: 318px;

  .send_text {
    height: 40px;
    width: 101px;
    height: 40px;
    border-radius: 3px;
    border: solid 1px #1c8c7a;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1c8c7a;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.personal-content {
  // width: 992px;
  // background-color: #ffffff;
  // box-shadow: 2px 2px 10px 0px rgba(1, 26, 13, 0.1);
  position: relative;
  min-height: 100%;
  display:flex;
  flex-direction:column;

  .personal-contenter {
    // width: 992px;
    // height: 352px;
    // box-shadow: 2.1px 2.1px 10px 0 rgba(1, 26, 13, 0.1);
    background-color: #fff;
    padding-top:16px;
    padding-left:40px;
    padding-right: 122px;
    flex:1;
    .title{
      font-size: 18px;
      color: #333333;
      font-weight: 700;
      position:relative;
      width:72px;
      text-align: center;
      z-index:2;
    }

    .title:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: -3px;
      width:100%
      height:6px;
      background:#26d99d;
      border-radius: 35px;
      z-index:-1;
    }
    .personal-centenr {
      padding-top: 9px;
      display: flex;
      align-items: center;

      // position:relative;
      .personal-account {
        width: 130px;
        display: flex;
        align-items: center;
        height: 33px;
        justify-content: center;
        padding-bottom: 5px;
        // line-height: 33px;
        text-align: center;
        margin-top: 9px;
        // box-shadow: 2.1px 2.1px 3px 0 rgba(0, 0, 0, 0.11);
        background: url('../../assets/img/user-center/arrow.png') no-repeat;
        background-size: 100% 100%;
        background-position: 0px 0px;
        // background-image: linear-gradient(to top, #58c0ab, #359594);
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        position: relative;
        left: -4px;
      }

      .personal-size {
        font-size: 12px;
        color: #999;
        margin-left: 11px;
        padding-top: 9px;
      }
    }

    .open-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .link {
        height: 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        width:340px;
        >img{
          width:40px;
          height:40px;
          margin-right: 16px;
        }
        .account_icon_item {
          font-size: 60px;
          color: #dddddd;
        }

        .account_icon_item_active {
          color: #4aafa2;
        }
        .text {
          // flex: 1;
          &>h6 {
            // margin-bottom: 17px;
            font-size: 14px;
            color: #333333;
            padding-bottom: 7px;
            width: 190px;
          }

          &>.has_verify {
            color: #1c8c7a;
          }

          &>p {
            font-size: 12px;
            color: #ccc;
          }
        }

        // button {

        // }
        .activeClass {
          // width: 100px;
          // height: 40px;
          // border-radius: 2px;
          // border: solid 1px #1c8c7a;
          // background-color: transparent;
          // color: #1c8c7a;
          // margin-left: 31px;
          // font-size: 14px;
        }

        .errorClass {
          margin-left: 31px;
          border: solid 1px #1c8c7a;
          width: 100px;
          height: 40px;
          color: #000;
          border-radius: 2px;
          background-color: #ddd;
          cursor: default;
        }
        button{
          width: 89px;
          height: 24px;
          background: #F7F7F7;
          border: 1px solid #F0F0F0;
          border-radius: 12px;
          font-size: 14px;
          color: #666;
          display: flex;
          align-items: center;
          box-shadow: 2.1px 2.1px 10px 0 rgba(1, 26, 13, 0.1);
          justify-content: center;
        }
        .edit-phone {
          width: 89px;
          height: 24px;
          background: #F7F7F7;
          border: 1px solid #F0F0F0;
          border-radius: 12px;
          font-size: 14px;
          color: #666;
          display: flex;
          align-items: center;
          text-align: center;
          box-shadow: 2.1px 2.1px 10px 0 rgba(1, 26, 13, 0.1);
          justify-content: center;
        }
      }

      .top {
        margin-top: 47px;
      }
    }
  }

  .personallink {
    height: 290px;
    margin-top: 23px;
  }
}
</style>
